export default {
    "en": {
        "Login": "Login",
        "E-Mail Address": "E-Mail Address",
        "Password": "Password",
        "Remember Me": "Remember Me",
        "Forgot Your Password?": "Forgot Your Password?",
        "Required.": "Required.",
        "The email or password is incorrect.": "The email or password is incorrect.",
        "Login successfully!": "Login successfully!",
        "Devices": "Devices",
        "List": "List",
        "Add": "Add",
        "Edit": "Edit",
        "List Devices": "List Devices",
        "Logout": "Logout",
        "Delete": "Delete",
        "App Name": "VLXD Ngọc Bích",
        "Employee": "Employee",
        "employee": "employee",
        "Attributes": "Attributes",
        "attributes": "attributes",
        "Sub Attributes": "Sub Attributes",
        "sub attributes": "sub attributes",
        "Product Attributes": "Product Attributes",
        "product attributes": "product attributes",
        "Flows": "Flows",
        "Flow Attributes": "Flow Attributes",
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "common": {
            "login": "login"
        },
        "pagination": {
            "previous": "« Previous",
            "next": "Next »"
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        }
    },
    "vi": {
        "Login": "Đăng nhập",
        "E-Mail Address": "Email",
        "Password": "Mật khẩu",
        "Remember Me": "Nhớ đăng nhập lần sau",
        "Forgot Your Password?": "Quên mật khẩu?",
        "Required.": "Yêu cầu.",
        "The email or password is incorrect.": "Email hay mật khẩu không đúng.",
        "Login successfully!": "Đăng nhập thành công!",
        "Devices": "Thiết Bị",
        "List": "Danh sách",
        "Add": "Thêm",
        "Edit": "Sửa",
        "List Devices": "Danh sách Thiết Bị",
        "Logout": "Đăng xuất",
        "Delete": "Xóa",
        "App Name": "VLXD Ngọc Bích",
        "Employee": "Nhân viên",
        "employee": "nhân viên",
        "Attributes": "Thuộc tính",
        "attributes": "thuộc tính",
        "Sub Attributes": "Thuộc tính con",
        "sub attributes": "thuộc tính con",
        "Product Attributes": "Thuộc tính sản phẩm",
        "product attributes": "thuộc tính sản phẩm",
        "Flows": "Flows",
        "Flow Attributes": "Flow Attributes",
        "Actions": "Hoạt động",
        "Update": "Cập nhật",
        "Select a ": "Chọn ",
        "Page": "Trang",
        "of": "của ",
        "No data found!": "Không có dữ liệu!",
        "Are you sure you want to delete?": "Bạn có chắc là muốn xóa không?",
        "Yes": "Có",
        "No": "Không",
        "Code": "Mã",
        "ID": "Mã số",
        "Full Name": "Họ và tên",
        "Username": "Tên đăng nhập",
        "Phone": "Điện thoại",
        "Password Confirm": "Xác nhận",
        "Registered Date": "Ngày đăng ký",
        "Position": "Vị trí",
        "Name": "Tên",
        "Cancel": "Hủy",
        "Must be greater than 0.": "Phải lớn hơn 0.",
        "Email": "Email",
        "Date From": "Từ ngày",
        "Date To": "Đến ngày",
        "loading": "đang tải",
        "Sign In": "Đăng nhập",
        "Sign Up": "Đăng ký",
        "or Username/Email": "hay Username/Email",
        "or Phone": "hay số điện thoại",
        "Checkout": "Đặt hàng",
        "Search for products, categories, suppliers ..": "Sản phẩm, danh mục, nhà cung cấp ..",
        "The phone or password is incorrect.": "Số điện thoại hay mật khẩu không đúng.",
        "Welcome": "Chào",
        "Sign up successfully!": "Đăng kí thành công!",
        "Not matched.": "Mật khẩu nhập lại không khớp!",
        "Must have at least 6 characters.": "Ít nhất 6 kí tự!",
        "Password at least one uppercase letter, one lowercase letter and one number.": "Ít nhất gồm chữ hoa, chữ thường và số!",
        "The phone has already been taken!": "Số điện thoại đã tồn tại!",
        "Registration failed!": "Đăng ký không thành công!",
        "Registration success.": "Đăng ký thành công.",
        "New Password": "Mật khẩu mới",
        "Repeat Password": "Xác nhận mật khẩu",
        "Full Address": "Địa chỉ",
        "Profile Info": "Thông tin cá nhân",
        "Update success.": "Cập nhật thành công.",
        "Update failed!": "Cập nhật thất bại!",
        "Home": "Trang chủ",
        "Products": "Sản phẩm",
        "Contact Us": "Liên hệ",
        "Manage": "Quản lý",
        "Cart": "Giỏ hàng",
        "Order Success. Please wait for confirmation from the store.": "Đặt hàng thành công. Vui lòng chờ xác nhận bên cửa hàng.",
        "Order": "Đơn hàng",
        "Order History": "Lịch sử mua hàng",
        "Date": "Ngày",
        "Image": "Hình ảnh",
        "Product Name": "Tên SP",
        "Product Code": "Mã SP",
        "Unit": "ĐVT",
        "Quantity": "Số lượng",
        "Status": "Trạng thái",
        "Pending": "Chờ xác nhận",
        "Request shows price": "Yêu cầu giá",
        "Approved": "Đã xác nhận",
        "Move to bill": "Chuyển HD",
        "Success.": "Thành công.",
        "Failure.": "Thất bại.",
        "Delete Order": "Xóa đơn hàng",
        "Not Approved": "Hết hạn",
        "List Online Detail": "Danh sách trực tuyến",
        "Role": "Vai trò",
        "Country": "Quốc gia",
        "City": "Thành phố",
        "Device": "Thiết bị",
        "Browser": "Trình duyệt",
        "Guest": "Khách",
        "Our Policy": "Chính sách của chúng tôi",
        "Continue": "Tiếp tục",
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "common": {
            "login": "Đăng nhập"
        },
        "pagination": {
            "previous": "« Previous",
            "next": "Next »"
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        }
    }
}
